import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-datetime',
	standalone: false,
	templateUrl: './dynamic-form-input-datetime.component.html',
	styleUrl: './dynamic-form-input-datetime.component.scss'
})
export class DynamicFormInputDatetimeComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	toControlKey = AbstractDynamicForm.toControlKey;

}
